<script setup lang="ts">
import { Order } from '@/@types/order'
import { Card, CardContent } from '@/components/ui/card'

defineProps<{ order: Order }>()
</script>

<template>
    <Card class="border-transparent">
        <CardContent class="pt-6">
            <h2 class="font-sans text-2xl font-semibold text-gray-800">{{ $t('Cancellation details') }}</h2>

            <ul class="space-y-4 font-sans text-sm text-gray-600 pt-6">
                <li v-if="order.cancel_reason">
                    <span class="font-medium text-slate-800"> {{ $t('Reason') }}: </span>
                    {{ $t(`cancel_reason.${order.cancel_reason}`) }}
                </li>
                <li v-if="order.cancel_justification">
                    <span class="font-medium text-slate-800"> {{ $t('Justification') }}: </span>
                    {{ order.cancel_justification }}
                </li>
            </ul>
        </CardContent>
    </Card>
</template>
